'use strict';

module.exports = require('./Tooltip');


//////////////////
// WEBPACK FOOTER
// ./~/.3.4.2@rc-tooltip/lib/index.js
// module id = 470
// module chunks = 0